import { useEffect } from 'react';
import NavigationService from '@/services/NavigationService/NavigationService';
import QueryParamsService from '@/services/QueryParamsService/QueryParamsService';

export const useUrlQueryParamsEffect = (paramKey: string, callback: () => void) => {
  const hasNavigateFunc = NavigationService.getNavigate();

  useEffect(() => {
    const paramValue = QueryParamsService.get(paramKey);

    if (paramValue && hasNavigateFunc) {
      callback();
      QueryParamsService.delete(paramKey);
    }
  }, [paramKey, callback, hasNavigateFunc]);
};
